/**
 * Nav collapse persistence (DNKADM-0302) — whether the side nav renders as
 * the full drawer or the mini icon rail. Mirrors the `navGroupExpansion` /
 * `ThemeModeContext` localStorage pattern: an in-memory `useState` seeded
 * once from storage, read and write try/catch-guarded (private mode /
 * unavailable storage falls back to expanded, unpersisted). Per device by
 * construction — localStorage is the device's.
 */
import { useState } from 'react';

const STORAGE_KEY = 'dink_admin_nav_collapsed';

function readStoredCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function useNavCollapse() {
  const [collapsed, setCollapsed] = useState(readStoredCollapsed);

  function toggleCollapsed() {
    setCollapsed((previous) => {
      const next = !previous;
      try {
        localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        /* localStorage unavailable — preference not persisted */
      }
      return next;
    });
  }

  return { collapsed, toggleCollapsed };
}
